import { createStyles } from '@material-ui/core/styles';
import { flexAlignCenter, flexAlignStart } from 'UI/utils/styles';

const ICON_PADDING = 3;

export const styles = theme =>
  createStyles({
    mainContainer: {
      ...flexAlignCenter
    },
    mainText: {
      color: theme.palette.grey.black
    },
    iconButton: {
      display: 'flex',
      gridColumn: '1 / 2',
      gridRow: '1 / 2',
      paddingTop: ICON_PADDING,
      alignSelf: 'start'
    },
    actionButtonContainer: {
      marginLeft: theme.spacing(1),
      display: 'inline-flex'
    },
    mainTitleContainer: {
      alignItems: 'center',
      gridColumn: '3 / 2',
      gridRow: '1 /2'
    },
    titleContainer: {
      ...flexAlignStart,
      flexDirection: 'column'
    },
    subtitle: {
      gridColumn: '2 / 3',
      gridRow: '2 / 3'
    },
    titleLabelGrid: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      gridTemplateRows: 'auto 1fr '
    }
  });
